<template>
  <v-container fluid>
    <v-row dense>
      <v-col
        v-for="(role, i) in roles"
        :key="i"
      >
        <v-fab-transition>
          <v-card
            class="team-member"
          >
            <v-card-text>
              <div>
                <v-avatar>
                  <img :src="avatarImg(role.email)">
                </v-avatar>
                <span
                  v-if="role.isPrimary"
                  class="display-1 text--primary"
                >
                  <v-btn
                    color="green"
                    dark
                    text
                  >
                    <v-icon
                      left
                      color="green"
                    >
                      mdi-star-circle
                    </v-icon>
                    Primary
                  </v-btn>
                </span>
              </div>
              <div class="display-2 text--primary">
                <span v-text="role.troodyRoleName" />
              </div>
              <div
                v-if="role.userName"
                class="display-1 text--primary"
              >
                <span v-text="role.userName" />
              </div>
              <div
                v-if="role.email"
                class="display-1 text--primary"
              >
                <v-icon>mdi-email</v-icon>
                <a
                  :href="'mailto:${role.email}'"
                  v-text="role.email"
                />
              </div>
              <div
                v-if="role.phoneNumber"
                class="display-1 text--primary"
              >
                <v-icon>mdi-phone</v-icon>
                <span v-text="role.phoneNumber" />
              </div>
            </v-card-text>
          </v-card>
        </v-fab-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import md5 from 'md5'

  export default {
    name: 'GroupSummaryTeamFields',

    props: {
      roles: {
        type: Array,
        default: null,
      },
    },

    methods: {
      avatarImg (data) {
        const email = (data || 'unknown@unknown.com')
        const img = [
          '//www.gravatar.com/avatar/',
          md5(email.trim().toLowerCase()),
          '?s=80', // 80 pixels
          '&d=mm', // Default (mystery man)
          '&r=pg', // PG Rating
        ]
        return img.join('')
      },
    },

  }
</script>
